import { render } from "./Slide10.vue?vue&type=template&id=291a3b82&scoped=true"
import script from "./Slide10.vue?vue&type=script&lang=js"
export * from "./Slide10.vue?vue&type=script&lang=js"

import "./Slide10.vue?vue&type=style&index=0&id=291a3b82&lang=scss&scoped=true"
import "./Slide10.vue?vue&type=style&index=1&id=291a3b82&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291a3b82"]])

export default __exports__